import SvgIcon from './SvgIcon';

const TraitIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      fill={props.fill}
      d="M23.244 17.009H.75c-.413 0-.75.36-.75.801v3.421c0 .423.337.769.75.769h22.494c.414 0 .75-.346.75-.77v-3.42c0-.441-.336-.801-.75-.801zm0-8H.75c-.413 0-.75.36-.75.801v3.421A.76.76 0 0 0 .75 14h22.494a.76.76 0 0 0 .75-.769V9.81c0-.441-.336-.801-.75-.801zm0-8H.75c-.413 0-.75.36-.75.801v3.42c0 .423.337.769.75.769h22.494a.76.76 0 0 0 .75-.769V1.81c0-.441-.336-.801-.75-.801z"
    />
  </SvgIcon>
);

TraitIcon.defaultProps = {
  width: 24,
  height: 24,
  fill: '#4779c6',
};

TraitIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  fill: PropTypes.string,
};

export default TraitIcon;
